import * as Yup from "yup";
import { VALIDATION_ERRORS } from "../../Contract/validation/translations";
import { StringSchema } from "yup";

Yup.addMethod<StringSchema>(Yup.string, "numbers", function() {
  return this.matches(/^\d+$/, VALIDATION_ERRORS.ONLY_NUMBERS);
});
